import React, {Component}  from 'react';
import {Input} from 'antd';


class Grides extends Component {
    state = {

    }

    sudotypeList={
        4:{
            split_w:2,
            split_h:2,
            split_w_num:4,
            gride_size : 50
        },
        6:{
            split_w:3,
            split_h:2,
            split_w_num:6,
            gride_size : 40

        },
        9:{
            split_w:3,
            split_h:3,
            split_w_num:9,
            gride_size :35
        }
    }

    getSudoku = ()=>{
        const sudotype = this.sudotypeList[this.props.type]


        let grids = this.props.show_list.map((d,i)=>{
                let rowIndex = parseInt(i/sudotype.split_w_num )  //行数
                let colIndex = parseInt(i%sudotype.split_w_num )  //列数

                let iscellRight = colIndex%sudotype.split_w===sudotype.split_w-1//是否是宫内的右侧格子
                let iscellBottom = rowIndex%sudotype.split_h===sudotype.split_h-1//是否是宫内的下侧格子
                let isTopcellTop = rowIndex===0//是否是最上的宫的宫内的上侧格子
                let isLeftcellLeft =  colIndex===0//是否是最左的宫内的左侧格子

                return <div key={i}
                            style={{
                                // margin:1,
                                position:'relative',
                                float:'left',
                                fontSize:14,
                                textAlign: 'center',
                                width:sudotype.gride_size,
                                height:sudotype.gride_size,
                                lineHeight: sudotype.gride_size+'px',
                                boxSizing:'border-box',
                                border:'1px solid #666',
                                borderTopWidth:isTopcellTop?'2px':'0px',
                                borderBottomWidth:iscellBottom?'2px':'1px',
                                borderLeftWidth:isLeftcellLeft?'2px':'0px',
                                borderRightWidth:iscellRight?'2px':'1px',

                            }}

                >
                    <span style={{
                        background:d==='x'?'#bbb':/^\^[1-9]/.exec(d)?'#f03':'#f5f5f5',
                        fontSize:d==='x'?22:14,
                        height:'100%',
                        width:'100%',
                        position:'absolute',
                        top:0,
                        left:0,}}>{d.replace('^','')}</span>


                </div>
            }

        )
        return grids
    }
    render(){
        const sudotype = this.sudotypeList[this.props.type]

        return(
            <div style={{width:(sudotype.split_w_num+1)*sudotype.gride_size-1}}>
                <div style={{overflow:'hidden',}}>
                {
                    this.getSudoku()
                }
                </div>
            </div>
        );
    }
}

export default Grides


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/ai_sudoku/gridesView.js